/**
 * React Query hooks for Reports
 */
import { useQuery } from '@tanstack/react-query';
import {
  getDashboardMetrics,
  getClientVisitsReport,
  getStaffTimeReport,
  getCANSComplianceReport,
  getDemographicsReport,
  getDonorReport,
  ReportParams,
} from '../services/reportsService';

const STALE = 5 * 60 * 1000; // 5 minutes

export function useDashboardMetrics() {
  return useQuery({
    queryKey: ['reports', 'dashboard'],
    queryFn: getDashboardMetrics,
    staleTime: STALE,
  });
}

export function useClientVisitsReport(params: ReportParams) {
  return useQuery({
    queryKey: ['reports', 'client-visits', params],
    queryFn: () => getClientVisitsReport(params),
    staleTime: STALE,
  });
}

export function useStaffTimeReport(params: ReportParams) {
  return useQuery({
    queryKey: ['reports', 'staff-time', params],
    queryFn: () => getStaffTimeReport(params),
    staleTime: STALE,
  });
}

export function useCANSComplianceReport() {
  return useQuery({
    queryKey: ['reports', 'cans-compliance'],
    queryFn: getCANSComplianceReport,
    staleTime: STALE,
  });
}

export function useDemographicsReport() {
  return useQuery({
    queryKey: ['reports', 'demographics'],
    queryFn: getDemographicsReport,
    staleTime: STALE,
  });
}

export function useDonorReport(params: ReportParams) {
  return useQuery({
    queryKey: ['reports', 'donor', params],
    queryFn: () => getDonorReport(params),
    staleTime: STALE,
  });
}
